import { render } from "./comparison-grid.vue?vue&type=template&id=daccfdd0"
import script from "./comparison-grid.vue?vue&type=script&lang=js"
export * from "./comparison-grid.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__